import { cn } from '@/context/global/utils/cn';

export type IconPauseProps = {
  className?: string;
  size?: number;
};

export default function IconPause({ className = '', size = 32 }: IconPauseProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <path
        d="M11.76 5.33337H9.09333C7.14667 5.33337 6 6.48004 6 8.42671V23.5734C6 25.52 7.14667 26.6667 9.09333 26.6667H11.76C13.7067 26.6667 14.8533 25.52 14.8533 23.5734V8.42671C14.8533 6.48004 13.7067 5.33337 11.76 5.33337Z"
        fill="currentColor"
      />
      <path
        d="M22.9066 5.33337H20.24C18.2933 5.33337 17.1466 6.48004 17.1466 8.42671V23.5734C17.1466 25.52 18.2933 26.6667 20.24 26.6667H22.9066C24.8533 26.6667 26 25.52 26 23.5734V8.42671C26 6.48004 24.8533 5.33337 22.9066 5.33337Z"
        fill="currentColor"
      />
    </svg>
  );
}
